var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("小程序配置"),
              ]),
              _c("div", { staticClass: "section-tip" }, [
                _vm._v("配置用于独立商户打包小程序"),
              ]),
              _c(
                "a-form",
                { staticClass: "setting-form" },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "小程序名称",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                        required: "",
                      },
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "请输入小程序名称" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "原始ID",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                        required: "",
                      },
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "请输入小程序原始ID" },
                        model: {
                          value: _vm.form.originalAppId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "originalAppId", $$v)
                          },
                          expression: "form.originalAppId",
                        },
                      }),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v("获取方式：微信公众平台-设置-账号信息-原始ID"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "AppID(小程序ID)",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                        required: "",
                      },
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "请输入小程序AppID" },
                        model: {
                          value: _vm.form.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appId", $$v)
                          },
                          expression: "form.appId",
                        },
                      }),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          "获取方式：微信公众平台-开发-开发设置-开发者ID-小程序AppID"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "AppSecret(小程序密钥)",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                        required: "",
                      },
                    },
                    [
                      _c(
                        "a-input",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            type: _vm.secretType,
                            placeholder: "请输入小程序AppSecret",
                          },
                          model: {
                            value: _vm.form.appSecret,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "appSecret", $$v)
                            },
                            expression: "form.appSecret",
                          },
                        },
                        [
                          _c("a-icon", {
                            attrs: {
                              slot: "suffix",
                              type: _vm.secretVisible ? "eye" : "eye-invisible",
                            },
                            on: {
                              click: function ($event) {
                                _vm.secretVisible = !_vm.secretVisible
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          "获取方式：微信公众平台-开发-开发设置-开发者ID-小程序AppSecret"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "代码上传秘钥",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                      },
                    },
                    [
                      _c("a-textarea", {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "请输入privKey", rows: 4 },
                        model: {
                          value: _vm.form.privKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "privKey", $$v)
                          },
                          expression: "form.privKey",
                        },
                      }),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          "获取方式：微信公众平台-开发-开发设置-小程序代码上传-小程序代码上传密钥,并关闭ip白名单"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "扫码直达域名",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                      },
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          placeholder:
                            "如：https://scancode.example.com（已备案）",
                        },
                        model: {
                          value: _vm.form.scanDomain,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "scanDomain", $$v)
                          },
                          expression: "form.scanDomain",
                        },
                      }),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          '配置后桌码二维码生成为链接码，顾客微信扫码直达小程序点餐页（需在微信公众平台"扫普通链接二维码打开小程序"中添加规则，测试链接可绑体验版）'
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "小程序码打开版本",
                        labelCol: _vm.formLabelCol,
                        wrapperCol: _vm.formWrapperCol,
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "200px" },
                          model: {
                            value: _vm.form.wxacodeEnv,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "wxacodeEnv", $$v)
                            },
                            expression: "form.wxacodeEnv",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "trial" } }, [
                            _vm._v("体验版（未发布小程序）"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "release" } },
                            [_vm._v("正式版（已发布）")]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          "生成桌台小程序码（菊花码）时打开的版本；小程序发布后请切换为正式版"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-footer" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }